export const PPT_TEXT_MIN_LENGTH = 300;
export const PPT_TEXT_MAX_LENGTH = 20_000;
export const FILE_SOURCE_TEXT_MIN_LENGTH = 10;
export const FILE_SOURCE_TEXT_MAX_LENGTH = 6_000;

export function normalizePptText(value: unknown): string {
  return typeof value === "string" ? value.slice(0, PPT_TEXT_MAX_LENGTH) : "";
}

export function validatePptTextLength(value: string): string {
  const length = value.trim().length;
  if (!length) return "请输入主题或资料内容。";
  if (length < PPT_TEXT_MIN_LENGTH) return `主题或资料内容至少需要 ${PPT_TEXT_MIN_LENGTH} 字。`;
  return "";
}

export function normalizeFileSourceText(value: unknown): string {
  return typeof value === "string" ? value.slice(0, FILE_SOURCE_TEXT_MAX_LENGTH) : "";
}

export function validateFileSourceTextLength(value: string): string {
  const length = value.trim().length;
  if (!length) return "";
  if (length < FILE_SOURCE_TEXT_MIN_LENGTH) {
    return `资料内容至少需要 ${FILE_SOURCE_TEXT_MIN_LENGTH} 字，或保持为空。`;
  }
  if (length > FILE_SOURCE_TEXT_MAX_LENGTH) {
    return `资料内容不能超过 ${FILE_SOURCE_TEXT_MAX_LENGTH.toLocaleString()} 字。`;
  }
  return "";
}
